/**
 * @file 追跡者テーブル
 */
'use strict'

/**
 * @classname TableTracking
 * @classdesc 追跡者テーブル
 */
export default class TableTracking {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#table-tracking')
	 */
	constructor($e) {
		console.log(`TableTracking.constructor`)
		this._$wrap = $e.closest('.table-responsive')
		this._$firstTrTh = $e.find('.tr').eq(0).find('.th').eq(0);
		this._fixWidth = $e.find('.thead .tr').eq(0).find('.th').eq(1).width() + 8
		console.log(`fixWidth: ${this._fixWidth}`);
		setInterval(()=> this.scrollX(), 200)
	}


	/**
	 * 初期化
	 *
	 * @memberof TableTracking
	 */
	scrollX() {
		const scrollLeft = this._$wrap.scrollLeft();
		if(scrollLeft > this._fixWidth) {
			this._$firstTrTh.addClass('sticky')
		} else {
			this._$firstTrTh.removeClass('sticky')
		}
	}
}
